import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class UpcomingService {

  UPCOMING_API_BASE_URL= SERVER_API_URL+'awards/upcoming/';

  constructor(private http: HttpClient) { }

  getUpcoming(regionCodes: string[]) : Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get<any>(this.UPCOMING_API_BASE_URL, { params: options});
  }
}
